import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import PageHeader from "../../components/PageHeader/PageHeader";
import { toast } from "react-toastify";
import { URLS } from "../../Services/Constant";
import { post, put } from "../../Services/ApiHandler";


const SubscriptionView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { item, type } = location.state || {};
  const isViewMode = type === "view";

  const [isEditing, setIsEditing] = useState(!isViewMode);
  const [originalData, setOriginalData] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    amount: "",
    type: "1",
    validity: "",
    postPerDay: "",
    postInterval: "",
  });

  useEffect(() => {
    if (isViewMode && item) {
      const prefilled = {
        name: item?.name || "",
        amount: item?.amount || "",
        type: item?.type || "1",
        validity: item?.days || "",
        postPerDay: item?.postperday || "",
        postInterval: item?.food_creation_interval || "",
      };
      setFormData(prefilled);
      setOriginalData(prefilled);
      setIsEditing(false);
    }
  }, [item, isViewMode]);

  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSubmit = async () => {
    const requiredFields = [
      { key: "name", label: "Name" },
      { key: "amount", label: "Amount" },
      { key: "validity", label: "Plan Validity" },
      { key: "postPerDay", label: "Post per day" },
      { key: "postInterval", label: "Post interval" },
    ];

    const missingField = requiredFields.find(
      ({ key }) => !String(formData[key] || "").trim()
    );

    if (missingField) {
      toast.error(`${missingField.label} is required`);
      return;
    }

    const payload = {
      id: item?.id,
      name: formData.name,
      days: formData.validity,
      food_creation_interval: formData.postInterval,
      postperday: formData.postPerDay,
      amount: formData.amount,
      type: formData.type,
    };

    if (isViewMode) {
      const res = await put(`${URLS.SUBSCRIPTIONUPDATE}${item?.id}/`, payload);
      if (res?.status === "success") {
        toast.success(res?.message);
        navigate("/subscription");
      }
    } else {
      const res = await post(URLS.SUBSCRIPTIONCREATE, payload);
      if (res?.status === "success") {
        toast.success(res?.message);
        navigate("/subscription");
      }
    }
  };

  const handleCancelEdit = () => {
    if (originalData) setFormData(originalData);
    setIsEditing(false);
  };

  return (
    <div>
      <PageHeader
        title={`${isViewMode ? (isEditing ? "Edit" : "View") : "Add"} Subscriptions`}
        showBackButton={true}
        onBackClick={() => navigate(-1)}
      />

      <div className="form-grid">
        {/* Name */}
        <div className="form-item">
          <div className="form-group">
            <label>Name</label>
            <input
              type="text"
              placeholder="Enter name"
              value={formData.name}
              onChange={(e) => handleChange("name", e.target.value)}
              disabled={isViewMode && !isEditing}
            />
          </div>
        </div>

        {/* Amount */}
        <div className="form-item">
          <div className="form-group">
            <label>Amount</label>
            <input
              type="number"
              placeholder="Rs 100"
              value={formData.amount}
              onChange={(e) => handleChange("amount", e.target.value)}
              disabled={isViewMode && !isEditing}
            />
          </div>
        </div>

        {/* Type */}
        <div className="form-item">
          <div className="form-group">
            <label>Type</label>
            <select
              value={formData.type}
              onChange={(e) => handleChange("type", e.target.value)}
              disabled={isViewMode && !isEditing}
            >
              <option value="1">Normal</option>
              <option value="2">Premium</option>
            </select>
          </div>
        </div>

        {/* Plan Validity */}
        <div className="form-item">
          <div className="form-group">
            <label>Plan Validity</label>
            <input
              type="text"
              placeholder="1 month"
              value={formData.validity}
              onChange={(e) => handleChange("validity", e.target.value)}
              disabled={isViewMode && !isEditing}
            />
          </div>
        </div>

        {/* Post per day */}
        <div className="form-item">
          <div className="form-group">
            <label>Post per day</label>
            <input
              type="number"
              placeholder="10"
              value={formData.postPerDay}
              onChange={(e) => handleChange("postPerDay", e.target.value)}
              disabled={isViewMode && !isEditing}
            />
          </div>
        </div>

        {/* Post interval */}
        <div className="form-item">
          <div className="form-group">
            <label>Post interval</label>
            <input
              type="text"
              placeholder="1 hour"
              value={formData.postInterval}
              onChange={(e) => handleChange("postInterval", e.target.value)}
              disabled={isViewMode && !isEditing}
            />
          </div>
        </div>
      </div>

      <div className="form-actions">
        {isViewMode ? (
          isEditing ? (
            <>
              <button className="header-action-btn" onClick={handleCancelEdit}>
                Cancel
              </button>
              <button className="header-action-btn" onClick={handleSubmit}>
                Save
              </button>
            </>
          ) : (
            <button className="header-action-btn" onClick={() => setIsEditing(true)}>
              Edit
            </button>
          )
        ) : (
          <button className="header-action-btn" onClick={handleSubmit}>
            + Create Subscription
          </button>
        )}
      </div>
    </div>
  );
};

export default SubscriptionView;
